<div class="tw-flex tw-w-full tw-justify-between tw-items-center tw-gap-2">
  <span class="tw-flex tw-gap-2 tw-items-center tw-overflow-hidden tw-text-sm tw-font-medium">
    <ng-content select="[slot=start]"></ng-content>
    <span class="tw-truncate"><ng-content></ng-content></span>
  </span>
  <span class="tw-flex tw-items-center tw-gap-2 tw-text-fg-body-subtle tw-text-xs empty:tw-hidden">
    <ng-content select="[slot=end]"></ng-content>
  </span>
</div>
